// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Vj-g","title":"styles_title__Bzk46"};